export default __webpack_public_path__ + "static/media/FDMPrintingProcessImg.7be7b6a5.png";